import React, { useState } from 'react';
import { postFileToCloudinary } from '../../../../api/cloudinaryAPI';
import UploadIcon from '../../shared/MediaUploadIcon';
import LoadingSpinner from '../../../../../assets/images/loading-spinner-white.svg';
import { Column, Row } from 'react-foundation';

const MediaUploadPopup = ({
	handleClose,
	handleMediaSubmission,
	name,
	setMediaFileName,
	orgID,
	handleClearingMedia,
	openCloudinaryWidget,
	setArticleData,
}) => {
	const [selectedURL, setSelectedURL] = useState('');
	const [selectedFile, setSelectedFile] = useState(undefined);
	const [isLoading, setIsLoading] = useState(false);

	const openWidgetAndClosePopup = (name) => {
		openCloudinaryWidget(name);
		handleClose();
	};

	/**
	 * Handles submitting of the media upload form
	 */
	const handleSubmit = async () => {
		if (selectedFile === undefined && selectedURL === '') {
			// Both link and file are empty -> User has not inputted anything and pressed save
			document.getElementById('no-file-or-link-label').style.display =
				'block';
		} else if (selectedFile !== undefined) {
			if (selectedURL !== '') {
				// File and URL entered
				document.getElementById(
					'both-file-and-link-label'
				).style.display = 'block';
			} else {
				// File entered by user, so upload it onto cloudinary
				try {
					setIsLoading(true);
					await postFileToCloudinary(
						selectedFile,
						handleMediaSubmission,
						name,
						orgID
					);
					setMediaFileName(selectedFile.name);
					handleClose();
				} catch (e) {
					console.error('Error posting image to Cloudinary: ' + e);
				}
			}
		} else {
			if (setArticleData) {
				setArticleData((prevState) => ({
					...prevState,
					img_url: selectedURL,
					file_name: selectedURL,
				}));
			}

			// Link entered by user
			handleMediaSubmission(name, selectedURL);
			setMediaFileName(selectedURL);
			handleClose();
		}
	};

	/**
	 * Responsible for clicking the actual file when the styled 'upload file' button is pressed
	 */
	const transferClick = () => {
		const fileElement = document.getElementById('file-input');
		if (fileElement) {
			fileElement.click();
		}
	};

	/**
	 * Handles changing of URL, and turns off error messages
	 * @param event
	 */
	const handleURLChange = (event) => {
		setSelectedURL(event.target.value);
		document.getElementById('both-file-and-link-label').style.display =
			'none';
		document.getElementById('no-file-or-link-label').style.display = 'none';
	};

	/**
	 * Handles changing of file, and turns off error messages
	 * @param event
	 */
	const handleFileChange = (event) => {
		setSelectedFile(event.target.files[0]);
		document.getElementById('both-file-and-link-label').style.display =
			'none';
		document.getElementById('no-file-or-link-label').style.display = 'none';
	};

	/**
	 * Handles clearing of the file and url field, then calls back to the function in NewOpportunity to clear it from
	 * oppData
	 */
	const handleClearingMediaAndInputFields = () => {
		setSelectedURL('');
		setSelectedFile(undefined);
		setMediaFileName('');
		document.getElementById('url-input-field').value = '';
		document.getElementById('file-input').value = '';
		handleClearingMedia(name);
	};

	return (
		<div>
			<div className="background-filter" onClick={handleClose} />
			<div className="file-upload-popup-outer">
				<i
					id="media-upload-close-button"
					className="fas fa-times float-right"
					onClick={handleClose}
				/>
				<div className="popup-inner">
					<h5 id="embed-link">Embed link</h5>
					<i id="media-link-icon" className="fas fa-link" />
					<input
						className="body-font-important"
						type="url"
						onChange={handleURLChange}
						name="url"
						id="url-input-field"
						placeholder="Enter an embed link here, or upload using the button below"
					/>
					<input
						type="file"
						onChange={handleFileChange}
						name="file"
						className="file-input"
						id="file-input"
					/>
					<div className="media-upload-button-wrapper">
						{/*<div className="button hollow media-upload-button" onClick={transferClick}>*/}
						<div
							className="media-upload-button"
							onClick={() => openWidgetAndClosePopup(name)}
						>
							<p className="media-upload-button-text ">
								Upload file
							</p>
							<UploadIcon />
						</div>
					</div>
					{selectedFile ? (
						<label id="selected-file-name">
							{' '}
							{selectedFile.name}
						</label>
					) : (
						''
					)}
					<label className="error-label" id="no-file-or-link-label">
						Please enter a link or file!
					</label>
					<label
						className="error-label"
						id="both-file-and-link-label"
					>
						Cannot enter both link and file!
					</label>

					<div className="bottom-30px-margin" />

					<Row>
						<Column medium={6} small={12}>
							<div
								className="secondary-button file-popup-button"
								onClick={handleClearingMediaAndInputFields}
							>
								<p>Clear</p>
							</div>
						</Column>

						<Column medium={6} small={12}>
							<div
								className="primary-button float-right file-popup-button mobile-button-margin-resizing"
								onClick={handleSubmit}
							>
								{isLoading ? (
									<img
										id="file-upload-loading-spinner"
										src={LoadingSpinner}
										alt="Loading spinner"
									/>
								) : (
									<p>Save</p>
								)}
							</div>
						</Column>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default MediaUploadPopup;
